/**
 * components/Eyebrow
 * The 10px mono uppercase label with 0.12em tracking that opens a section:
 * "POSITION", "RECORD A TRANSACTION", "TRANSACTION LEDGER · APPEND-ONLY".
 *
 * `dark` switches to the 11px ink-2 variant the drawer's action groups use.
 */
import { Text, type StyleProp, type TextStyle } from 'react-native';
import { type as textRole } from '../../theme/typography';

export interface EyebrowProps {
  children: string;
  dark?: boolean;
  style?: StyleProp<TextStyle>;
}

export function Eyebrow({ children, dark = false, style }: EyebrowProps) {
  return (
    <Text style={[dark ? textRole.eyebrowDark : textRole.eyebrow, style]}>{children}</Text>
  );
}

export default Eyebrow;
